<div *ngIf="!isRegistrationClosed" [ngClass]="{ 'hide-days-column': !hideDays }">
    <div [innerHTML]="htmlStyles | trustAsHtml"></div>
    <div [ngClass]="ribbonStatusClass" [innerHTML]="htmlTextUpdated | trustAsHtml"></div>
</div>
